import { Component, OnInit } from '@angular/core';
import {Publicite} from '../../../shared/components/models/publicite';
import {PubliciteService} from '../../../core/services/publicite.service';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-pub-g',
  templateUrl: './pub-g.component.html',
  styleUrls: ['./pub-g.component.scss']
})
export class PubGComponent implements OnInit {
  pubG: Publicite;
  publicites: Publicite[] = [];
  publiciteImageUri: string;
  constructor(private publiciteService: PubliciteService) {
    this.publiciteImageUri = environment.publiciteImageUri;
  }

  ngOnInit(): void {
    this.loadPublicite();
  }

  loadPublicite() {
    this.publiciteService.findPubG().subscribe(ret => {
      if (ret['status'] === 'OK') {
        this.publicites = ret['response'];
        // console.log(this.publicites);
        this.pubG = this.publicites.find(p=>p.type==='G');
      } else {
        // console.log('erreur survenu');
      }
    }, error => {
      // console.log('erreur server');
    });
  }
}
